import React from 'react';
import { NavLink } from 'react-router-dom';
import logoU from '../../assets/images/logo-u.png';
import imgSignin from '../../assets/images/signin-logo.png';
import imgDates from '../../assets/images/dates.png';

import styles from './signin.module.scss';

const SignIn = () => (
  <div className={styles.signin}>
    <div className={styles.logo}>
      <img src={logoU} alt= "Logo Coopérative U" />
    </div>
    <div className={styles.container}>
        <div className={styles.imgContainer}>
          <h1>Bienvenue au</h1>
          <img src={imgSignin} alt= "Bienvenue au salon U" />
          <img src={imgDates} alt= "Dates du salon" className={styles.dates}/>
        </div>
        <div className={styles.form}>
          <div className={styles.actions}>
            <NavLink to='/register-types'>
              <button>
                Je m&apos;inscris au salon 2026
              </button>
            </NavLink>
            <NavLink to='/modifier-inscription'>
              <button>
                Je modifie mon inscription au salon 2026
              </button>
            </NavLink>
            <NavLink to='/recuperer-badge' className={styles.caption}>
                Je veux récupérer mon badge
            </NavLink>
          </div>
        </div>
    </div>
  </div>
);

export default SignIn;
